import axios from 'axios'
import { DateTime } from 'luxon'
import React, { useEffect, useState } from 'react'
import { HiDotsVertical, HiInformationCircle } from 'react-icons/hi'
import { ColumnsTable, IFinance } from 'safe'
import AdvancedIncomeForm from '../../components/Display/AdvancedIncomeForm'
import FloatingForm from '../../components/Display/FloatingForm'
import FloatingMenu from '../../components/Display/FloatingMenu'
import Modal from '../../components/Display/Modal'
import ModalConfirm from '../../components/Display/ModalConfirm'
import Table from '../../components/Display/Table'
import { ColumnItemWrapper } from '../../components/General/ColumnItemWrapper'
import { HeaderProps } from '../../components/Layout/Header'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import { useLocalStorageState } from '../../hooks/useLocalStorageState'
import {
  dateToDB,
  formatPipe,
  formatter,
  getDenomination,
  getItemType,
  getYearMonthAndDay,
  transformDate,
} from '../../utils/utils'
import WatchSale from '../Sells/WatchSale'
import IncomeForm from './IncomeForm'
import { useSelector } from 'react-redux'
import { RootState } from '../../redux/store'
// import Income from '../Finances/'


const server = process.env.REACT_APP_SERVER_URL

const Income: React.FC<IncomeProps> = ({ setHeaderActions }) => {
  const [incomesInfo, setIncomesInfo] = useState<{
    incomes: IFinance[]
    numberOfPages: number
    loading: boolean
    currentPage: number
  }>({ incomes: [], numberOfPages: 0, loading: false, currentPage: 0 })

  const [menuVisible, setMenuVisible] = useState<any>()

  const [incomeToDelete, setIncomeToDelete] = useState<string | null>(null)

  const [showConfirmModal, setShowConfirmModal] = useState<boolean>(false)

  const [userConfig] = useLocalStorageState('user-config')

  const [modalSearch, setModalSearch] = useState<boolean>(false)

  const [searchParams, setSearchParams] = useState<string[]>([])

  const [showModalAdd, setShowModalAdd] = useState<boolean>(false)

  const { addAlert } = useSnackBars()

  const { incomes, numberOfPages, loading, currentPage } = incomesInfo

  // const [showIncome, setShowIncome] = useState<boolean>(false)

  const [selectedIncome, setSelectedIncome] = useState<any | null>(null)

  const [elementToView, setElementToView] = useState<any | null>(null)

  const [fastSearch, setFastSearch] = useState<string>('')

  const userRole = useSelector(
    (state: RootState) => state.auth.user['custom:user_role']
  )

  const getIncome = async (
    querySearch: string[] = searchParams,
    page: number = currentPage,
    fastParam = fastSearch

  ): Promise<void> => {
    setSearchParams(querySearch)
    setIncomesInfo((prevState) => ({
      ...prevState,
      currentPage,
      loading: true,
    }))
    setFastSearch(fastParam)

    let paginationParams: string[] = [
      `pageNumber=${page + 1}`,
      `pageSize=${userConfig.rowsPerPage}`,
    ]

    let newParams = [...querySearch]

    if (fastParam) {
      newParams.push(`fastSearch=${fastParam}`)
    }

    let response = await axios.get<{
      incomes: IFinance[]
      numberOfPages: number
    }>(`${server}/income?${[...paginationParams, ...newParams].join('&')}`)
    // setIncomes(incomes)

    setIncomesInfo((prevState) => ({
      ...prevState,
      incomes: response.data.incomes,
      loading: false,
      numberOfPages: +response.data.numberOfPages || 1,
    }))
  }

  useEffect(() => {
    getIncome()
  }, [])

  useEffect(() => {

    if (userRole === "seniat") {
      setHeaderActions({
        advancedSearch: (value) => {
          if (typeof value === 'boolean') {
            setModalSearch(true)
            return
          }
          // setSearchParams([`fastSearch=${value}`])
          // getIncome([`fastSearch=${value}`], 0)
          getIncome(searchParams, currentPage, value)
        },
        cleanFilters: {
          sort: () => {},
          search: () => {
            getIncome([], 0)
          },
          isSearch: Boolean(searchParams.length > 0),
        },
      })
    } else {
      setHeaderActions({
        addAction: () => {
          setShowModalAdd(true)
        },
        advancedSearch: (value) => {
          if (typeof value === 'boolean') {
            setModalSearch(true)
            return
          }
          // setSearchParams([`fastSearch=${value}`])
          // getIncome([`fastSearch=${value}`], 0)
          getIncome(searchParams, currentPage, value)
        },
        cleanFilters: {
          sort: () => {},
          search: () => {
            getIncome([], 0)
          },
          isSearch: Boolean(searchParams.length > 0),
        },
      })
    }
   
    return () => {
      setHeaderActions(null)
    }
  }, [setHeaderActions, searchParams, currentPage])

  const columns: ColumnsTable[] = [
    {
      title: 'Fecha',
      dataIndex: 'date',
      key: 'date',
      render: (id: number, record: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {record?.date ? transformDate(record?.date) : 'N/A'}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Monto',
      dataIndex: 'amount',
      key: 'amount',
      render: (id: number, record: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {`${getDenomination(record?.currency?.id)} ${formatPipe(
            record.amount
          )}`}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Cuenta',
      dataIndex: 'account.description',
      key: 'account.description',
      // render: (id: number, record: any) => (
      //   <ColumnItemWrapper
      //     subElement="paragraph"
      //     subElementStyle="dark:text-white text-black"
      //   >
      //     {record?.account?.description}
      //   </ColumnItemWrapper>
      // ),
    },
    {
      title: 'Referencia',
      dataIndex: 'reference',
      key: 'reference',
    },
    {
      title: 'Concepto',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Tipo',
      dataIndex: 'description',
      key: 'description',
      render: (id: number, record: any) => {
        let obj = {
          REPAY : "REINTEGRO",
          INSTALLMENT : "PAGO DE CUOTA",
          REFUND : "REEMBOLSO",
          SALE : "VENTA",
          BANK_LOAN : "CRÉDITO BANCARIO",
          LOAN : "PRÉSTAMO",
          INVESTMENT : "CAPITAL CONTRIBUIDO POR ACCIONISTAS",
          INTEREST : "INTERÉS",
          OTHER : "OTRO",
          CUSTOM : "AVANZADO",
          PROPERTY_SALE: 'VENTA DE INMUEBLE'
        }

        return (
          <ColumnItemWrapper>
            <p>{obj[record.type] || ''}</p>
          </ColumnItemWrapper>
        )
      },
    },
    // {
    //   title: 'Tipo de iva',
    //   dataIndex: 'ivaType',
    //   key: 'ivaType',
    //   render: (id: number, record: any) => {
    //     let objTransform = {
    //       GENERAL: 'GENERAL',
    //       REDUCED: 'REDUCIDO',
    //       EXEMPT: 'EXENTO',
    //       SUMPTUARY: 'SUNTUARIO',
    //     }
    //     return (
    //       <ColumnItemWrapper subElementStyle="dark:text-white text-black">
    //         <p>{objTransform[record.ivaType]}</p>
    //       </ColumnItemWrapper>
    //     )
    //   },
    // },
    {
      title: 'Emisor',
      dataIndex: 'client.name',
      key: 'client.name',
      render: (id: number, record: any) => (
        <ColumnItemWrapper>
          {record?.client?.name || record?.provider?.businessName || record?.otherPayer}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Usuario',
      dataIndex: 'username',
      key: 'username',
    },
    {
      title: '',
      dataIndex: 'id',
      align: 'right',
      width: 50,
      key: 'actions',
      render: (id: number, record: any) => (
        <ColumnItemWrapper floatingMenu>
          {/* <div className="text-gray-500 relative"> */}
          <FloatingMenu
            visible={menuVisible === id}
            onClose={() => {
              setMenuVisible(-1)
            }}
            options={{
              onDelete: () => {
                setIncomeToDelete(record.id)
                setShowConfirmModal(true)
              },
              watchIncome: async () => {
                // setSelectedIncome(record)
                // setShowIncome(true)
                try {
                  let response = await axios.get(
                    `${server}/income?id=${record?.id}`
                  )
                  setSelectedIncome(response.data.income)
                } catch (err) {
                  addAlert({
                    message: 'Error al obtener ingreso',
                    status: 'error',
                  })
                }
              },
            }}
          >
            <HiDotsVertical
              className="cursor-pointer dark:text-white text-primaryGray-400"
              onClick={() => {
                setMenuVisible(id)
                // setEdit(record)
                // setModal(true)
              }}
            />
          </FloatingMenu>
        </ColumnItemWrapper>
      ),
    },
  ]

  return (
    <>
      <Table
        columns={userRole === "seniat" ? columns.slice(0, -1) : columns}
        data={incomes}
        pages={numberOfPages}
        loading={loading}
        pageSelected={currentPage}
        setPageSelected={(page) => getIncome(searchParams, page)}
      />
      <FloatingForm
        visible={modalSearch}
        onClose={() => setModalSearch(false)}
        topClass="top-20"
        rightClass="right-10"
        containerClass="w-2/6"
      >
        <AdvancedIncomeForm
          onSubmit={async (values) => {
            console.log('values...', values)
            if (values.isDateSelected) {
              const [yearFrom, monthFrom, dayFrom] = getYearMonthAndDay(
                values.fromDate
              )
              const [yearTo, monthTo, dayTo] = getYearMonthAndDay(values.toDate)
              let from = new Date(yearFrom, monthFrom, dayFrom)
              let to = new Date(yearTo, monthTo, dayTo + 1)
  
              let dateFrom = DateTime.fromISO(from.toISOString()).toISODate()
              let datePrueba = DateTime.fromISO(to.toISOString()).toISODate()
              console.log('date prueba...', datePrueba)
  
              // let newTo = to.toISOString()
              // console.log("NEW", newTo.replace(/T.+/, '').replace(/\-/g, "/"))
              // console.log("TO", to.toLocaleDateString('en-US'))
              // let [year, month, day] = newTo.replace(/T.+/, '').replace(/\-/g, "/").split("/")
              // const [yearToNew, monthToNew, dayToNew] = getYearMonthAndDay(`${day}/${month}/${year}`)
  
              values.fromDate = dateFrom
  
              values.toDate = datePrueba

              // delete values.isDateSelected
            }

            if (!values.isDateSelected) {
              delete values.fromDate
              delete values.toDate
              delete values.isDateSelected
            }

            let params = Object.keys(values).reduce((a, b) => {
              if (values[b]) {
                return [...a, `${b}=${values[b]}`]
              }
              return a
            }, [] as any)
            await getIncome(params, 0)
            setModalSearch(false)
          }}
          onClose={() => setModalSearch(false)}
        />
      </FloatingForm>

      <Modal
        display={showModalAdd}
        onClose={() => setShowModalAdd(false)}
        xlClasses="w-[650px]"
      >
        <IncomeForm
          type="INCOME"
          onClose={() => setShowModalAdd(false)}
          onSubmit={async (values) => {
            console.log('values...', values)
            addAlert({
              message: 'Creando ingreso',
              status: 'loading',
            })
            try {
              await axios.post(`${server}/income`, values)
              await getIncome([], 0)
              setShowModalAdd(false)
              addAlert({
                message: 'Ingreso creado satisfactoriamente',
                status: 'success',
              })
            } catch (err) {
              addAlert({
                message: 'Error al crear ingreso',
                status: 'error',
              })
            }
          }}
        />
      </Modal>

      <ModalConfirm
        title={'¿Está seguro que desea eliminar este ingreso?'}
        displayConfirmModal={showConfirmModal}
        onCancel={() => setShowConfirmModal(false)}
        onConfirm={async () => {
          addAlert({
            message: 'Eliminando ingreso',
            status: 'loading',
          })
          try {
            await axios.delete(`${server}/income?id=${incomeToDelete}`)
            await getIncome([], 0)
            addAlert({
              message: 'Ingreso eliminado satisfactoriamente',
              status: 'success',
            })
          } catch (err) {
            addAlert({
              message: 'Error al eliminar ingreso',
              status: 'error',
            })
          } finally {
            setShowConfirmModal(false)
          }
        }}
      />

      <Modal display={!!selectedIncome} onClose={() => setSelectedIncome(null)}>
        <h2 className="col-span-12 mb-2 text-primary-900 font-bold mb-3">
        Info de Entrada
      </h2>

        <div className="grid grid-cols-12 gap-6">
          <div
            className="xl:col-span-6 p-5 lg:col-span-12"
            style={{ boxShadow: '0px 3px 4px 3px #cccccc40' }}
          >
            <div className="flex flex-row mb-2">
              <label className="font-bold">Descripción:</label>
              <label className="ml-2 truncate">
                {selectedIncome?.description}
              </label>
            </div>

            <div className="flex flex-row">
              <label className="font-bold">Usuario:</label>
              <label className="ml-2 truncate">
                {selectedIncome?.username}
              </label>
            </div>
          </div>

          <div
            className="xl:col-span-6 p-5 lg:col-span-12"
            style={{ boxShadow: '0px 3px 4px 3px #cccccc40' }}
          >
            <div className="flex flex-row mb-2">
              <label className="font-bold">Fecha:</label>
              <label className="ml-2 truncate">
                {DateTime.fromISO(selectedIncome?.date).toLocaleString({
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                })}
              </label>
            </div>

            <div className="flex flex-row mb-2">
              <label className="font-bold">Monto:</label>
              <label className="ml-2 truncate">
                {getDenomination(selectedIncome?.currency?.id)}{' '}
                {formatPipe(selectedIncome?.amount)}
              </label>
            </div>

            <div className="flex flex-row">
              <label className="font-bold">Referencia:</label>
              <label className="ml-2 truncate">
                {selectedIncome?.reference}
              </label>
            </div>
          </div>

          {selectedIncome?.sales?.length > 0 && (
            <div className="col-span-12">
              <div className="flex flex-row">
                <div className="text-primary">
                  <HiInformationCircle size={25} />
                </div>
                <label className="ml-3">
                  Este ingreso está asociado a las siguientes ventas:
                </label>
              </div>
              <div className="col-span-12 flex flex-row flex-wrap">
                {selectedIncome?.sales.map((sale) => (
                  <div
                    style={{ flexBasis: '32%' }}
                    className="mt-3 text-center"
                    key={sale?.id}
                    onClick={async () => {
                      // let id =
                      //       selectedIncome?.sales.length > 0
                      //         ? selectedIncome?.sales[0]?.id
                      //         : ''
                      //     let type: 'SALE' | 'PURCHASE' =
                      // selectedIncome?.sales.length > 0 ? 'SALE' : 'PURCHASE'
                      // let obj : any = {
                      //   type: selectedIncome?.sales.length > 0 ? 'SALE' : 'PURCHASE',
                      //   info: selectedIncome?.sales.length > 0 ? selectedIncome?.sales[0]?.id : ""
                      // }
                      let response = await axios.get(
                        `${server}/sale?id=${sale.id}`
                      )
                      setElementToView(response?.data?.sale)
                    }}
                  >
                    <label className="text-primary cursor-pointer ml-9">
                      {' '}
                      {sale?.invoiceCode
                        ? `Venta de factura Nmo ${sale?.invoiceCode}`
                        : 'Venta sin factura'}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* {selectedIncome?.sales?.length > 0 && (
            <div className="col-span-12">
              <div className="flex flex-row ml-3">
                <div className="flex items-center text-primary">
                  <HiInformationCircle size={25} />
                </div>

                <div className="flex flex-col ml-3">
                  <label>
                    Este ingreso está asociado a las siguientes ventas:
                  </label>
                  <label
                    className="text-primary cursor-pointer"
                    onClick={async () => {
                      let id =
                        selectedIncome?.sales.length > 0
                          ? selectedIncome?.sales[0]?.id
                          : ''
                      let type: 'SALE' | 'PURCHASE' =
                        selectedIncome?.sales.length > 0 ? 'SALE' : 'PURCHASE'
                      // let obj : any = {
                      //   type: selectedIncome?.sales.length > 0 ? 'SALE' : 'PURCHASE',
                      //   info: selectedIncome?.sales.length > 0 ? selectedIncome?.sales[0]?.id : ""
                      // }
                      let response = await axios.get(
                        `${server}/${
                          type === 'SALE' ? 'sale' : 'purchase'
                        }?id=${id}`
                      )
                      setElementToView({
                        type,
                        info: response?.data?.sale || response?.data?.purchase,
                      })
                    }}
                  >
                    Ver {selectedIncome?.sales.length > 0 ? 'venta' : ''}.
                  </label>
                </div>
                
              </div>

              <div className="h-px dark:bg-primaryGray-300 bg-primaryGray-300 col-span-12 mt-2"></div>
            </div>
          )} */}

          <div
            className="xl:col-span-6 p-5 lg:col-span-12"
            style={{ boxShadow: '0px 3px 4px 3px #cccccc40' }}
          >
            <div className="flex flex-row mb-2">
              <label className="font-bold">Cliente:</label>
              <label className="ml-2 truncate">
                {selectedIncome?.payer?.client?.name ||
                  selectedIncome?.payer?.provider?.businessname ||
                  selectedIncome?.payer?.other}
              </label>
            </div>

            <div className="flex flex-row">
              <label className="font-bold">Documento:</label>
              <label className="ml-2 truncate">
                {!selectedIncome?.payer?.other &&
                  `${
                    selectedIncome?.payer?.client?.documenttype ||
                    selectedIncome?.payer?.provider?.documenttype
                  }-${
                    selectedIncome?.payer?.client?.document ||
                    selectedIncome?.payer?.provider?.document
                  }`}
              </label>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        isFullHeight={true}
        xlClasses="xl:w-10/12 xl:h-5/6"
        innerStyle={{ height: '95%' }}
        display={!!elementToView}
        onClose={() => setElementToView(null)}
      >
        <WatchSale sale={elementToView} globalRate={null} />
      </Modal>
    </>
  )
}

interface IncomeProps {
  setHeaderActions: React.Dispatch<
    React.SetStateAction<HeaderProps['headerActions'] | null | undefined>
  >
}

export default Income